module.exports = __webpack_public_path__ + "static/media/29.4d6d92bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/29.jpg
// module id = 562
// module chunks = 0